import { render, staticRenderFns } from "./DriverDestinationsTab.vue?vue&type=template&id=82383362&scoped=true&"
import script from "./DriverDestinationsTab.vue?vue&type=script&lang=js&"
export * from "./DriverDestinationsTab.vue?vue&type=script&lang=js&"
import style0 from "./DriverDestinationsTab.vue?vue&type=style&index=0&id=82383362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82383362",
  null
  
)

export default component.exports